// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._item__row_4tulk_1 {
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  grid-auto-rows: 0;
  overflow: hidden;
}
@media (min-width: 1200px) {
  ._item__row_4tulk_1 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 36px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._item__row_4tulk_1 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  ._item__row_4tulk_1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 28px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  ._item__row_4tulk_1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
@media (min-width: 0px) and (max-width: 575px) {
  ._item__row_4tulk_1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
  }
}

._item__singleTable_4tulk_38 {
  padding-top: var(--perxis-auto-gap-vertical-sky-inner);
  padding-bottom: var(--perxis-auto-gap-vertical-sky-inner);
}

._item__label_4tulk_43 {
  /* Typography */
  --pa-comparison-equipments-item-group-label-color-inner: var(
    --pa-comparison-equipments-item-group-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* End Typography */
  --perxis-auto-typography-color-dark-light: var(--pa-comparison-equipments-item-group-label-color-inner);
}

._item__value_4tulk_53 {
  /* Typography */
  --pa-comparison-equipments-item-group-value-color-inner: var(
    --pa-comparison-equipments-item-group-value-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-typography-color-darkest: var(--pa-comparison-equipments-item-group-value-color-inner);
}

._item__icon_4tulk_63 {
  /* Colors */
  --pa-comparison-equipments-item-check-icon-color-inner: var(
    --pa-comparison-equipments-item-check-icon-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  --pa-comparison-equipments-item-minus-icon-color-inner: var(
    --pa-comparison-equipments-item-minus-icon-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Colors */
}
._item__icon--minus_4tulk_75 {
  color: var(--pa-comparison-equipments-item-minus-icon-color-inner);
}
._item__icon--check_4tulk_78 {
  color: var(--pa-comparison-equipments-item-check-icon-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
